const superAdministrator = [
    {
        icon: 'el-icon-lx-home',
        index: '/dashboard',
        title: '系统首页'
    },
    {
        icon: 'el-icon-lx-file',
        index: '1',
        title: '系统管理',
        subs: [
            {
                title: '系统预警',
                index: '1-1',
                subs: [
                    {
                        index: '/qqBot',
                        title: 'QQ机器人'
                    },
                    {
                        index: '/apiInfo',
                        title: '后端Api接口测试'
                    },
                    {
                        index: '/userNoticeConfig',
                        title: '预警账户'
                    },
                    {
                        index: '/systemLog',
                        title: '系统日志'
                    }
                ]
            },
            {
                title: '权限管理',
                index: '1-2',
                subs: [
                    {
                        index: '/roleInfo',
                        title: '角色信息'
                    },
                    {
                        index: '/permission',
                        title: '权限信息'
                    },
                    {
                        index: '/whiteUrl',
                        title: '白名单管理'
                    },
                    {
                        index: '/role',
                        title: '内部人员管理'
                    },
                    {
                        index: '/projectGroup',
                        title: '项目组信息'
                    }
                ]
            },
            {
                index: '1-3',
                title: '支付',
                subs: [
                    {
                        index: '/payEvent',
                        title: '订单事件'
                    }
                ]
            }
        ]
    },
    {
        icon: 'el-icon-lx-file',
        index: '2',
        title: '项目',
        subs: [
            {
                icon: 'el-icon-lx-addressbook',
                title: '实名相关',
                index: '2-1',
                subs: [
                    {
                        index: '/AntiProjectData',
                        title: 'ProjectData'
                    },
                    // {
                    //     index: 'AntiaddictionTest',
                    //     title: '本地白名单'
                    // },
                    {
                        index: '/projectSetting',
                        title: '项目防沉迷设置'
                    },
                    {
                        index: '/antiAddictionSetting',
                        title: '防沉迷模板设置'
                    }
                ]
            },
            // {
            //     index: 'ProjectPath',
            //     title: '项目信息'
            // },
            {
                title: '项目文件管理',
                index: '2-2',
                subs: [
                    {
                        index: '/projectFile',
                        title: '项目发布情况'
                    },
                    {
                        index: '/upload',
                        title: '项目上传'
                    },
                    {
                        index: '/ProjectInfo',
                        title: '文件信息'
                    },
                    {
                        index: '/resourceDownloadAuth',
                        title: '资源下载认证'
                    }
                ]
            },
            {
                title: '广告管理',
                index: '2-3',
                subs: [
                    {
                        index: '/advert',
                        title: '广告'
                    },
                    {
                        index: '/advertGroup',
                        title: '广告组'
                    }
                ]
            },
            {
                title: '项目管理',
                index: '2-4',
                subs: [
                    {
                        index: '/projectVersion',
                        title: '项目版本'
                    },
                    {
                        index: '/newProjectInfo',
                        title: '项目信息'
                    },
                    {
                        index: '/projectCustomSetting',
                        title: '项目自定义配置'
                    },
                    {
                        index: '/gameDetail',
                        title: '官网游戏详情'
                    },
                    {
                        index: '/appMd5',
                        title: '应用md5'
                    },
                    {
                        index: '/projectServiceStatus',
                        title: '项目服务器状态'
                    }
                ]
            },


        ]
    },
    {
        icon: 'el-icon-s-data',
        index: '4',
        title: '数据分析',
        subs: [
            {
                index: '/trackEvent',
                title: '事件管理'
            },
            {
                index: '/trackData',
                title: '埋点事件数据'
            },
            {
                index: '/trackAnalyse',
                title: '报表看板'
            }
        ]
    },
    {
        icon: 'el-icon-s-help',
        index: '14',
        title: '数据存储',
        subs: [
            {
                index: '/storage-application',
                title: '应用管理'
            }
        ]
    },
    {
        icon: 'el-icon-folder-opened',
        index: '5',
        title: '文件系统',
        subs: [
            {
                index: '/fileManager',
                title: '文件管理'
            },
            {
                index: '/exportTask',
                title: '导出数据'
            }
        ]
    },
    {
        icon: 'el-icon-trophy',
        index: '16',
        title: '运营',
        subs: [
            {
                index: '122',
                title: '玩家管理',
                subs: [
                    {
                        index: '/Players',
                        title: '玩家信息'
                    },
                    {
                        index: '/generatePlayer',
                        title: '生成玩家账号'
                    }
                ]
            },
            {
                index: '/giftCode',
                title: '礼包码'
            },
            {
                index: '/redemptionRecord',
                title: '礼包码兑换记录'
            },
            {
                index: '121',
                title: '项目Bug日志管理',
                subs: [
                    {
                        index: '/archiveList',
                        title: '日志列表'
                    },
                    {
                        index: '/archiveControl',
                        title: '日志上传控制'
                    }
                ]
            },
            {
                index: '125',
                title: '支付',
                subs: [
                    {
                        index: '/payOrder',
                        title: '订单列表'
                    }
                ]
            },
            {
                index: '/customer',
                title: '客服人员'
            }
        ]
    },
    {
        icon: 'el-icon-chat-dot-round',
        index: '/im',
        title: 'IM系统'

    },
    {
        icon: 'el-icon-lx-apps',
        index: '6',
        title: '设备相关',
        subs: [
            {
                index: '/deviceInfo',
                title: '设备信息'
            }
        ]
    },
    {
        icon: 'el-icon-s-tools',
        index: '7',
        title: 'GM 相关',
        subs: [
            {
                index: '/Gameconsole',
                title: 'GM 工具'
            },
        ]
    },
    {
        icon: 'el-icon-info',
        index: '9',
        title: '支付记录',
        subs: [
            {
                index: '/AliPay',
                title: '支付宝支付记录'
            },
            {
                index: '/WxPay',
                title: '微信支付记录'
            }
        ]
    },
    {
        icon: 'el-icon-info',
        index: '10',
        title: '商品相关',
        subs: [
            {
                index: '/Produce',
                title: '商品记录'
            }
        ]
    },
    {
        icon: 'el-icon-s-custom',
        index: '12',
        title: 'SVN相关',
        subs: [
            {
                index: '/svnStatus',
                title: 'SVN状态'
            },
            {
                index: '/svnManage',
                title: '人员管理'
            },
            {
                index: '/svnInsert',
                title: '人员新增'
            },
            {
                index: '/svnAuthorization',
                title: '访问规则'
            },
            {
                index: '/authorizationInfo',
                title: '备份信息'
            },
            {
                index: '/svnEditPersonal',
                title: '修改个人信息'
            },
            {
                title: '未登录'
            },
            {
                title: '登出'
            },
        ]
    }
]

const projectAdministrator = [
    {
        icon: 'el-icon-lx-home',
        index: 'dashboard',
        title: '系统首页'
    },
    {
        icon: 'el-icon-monitor',
        index: '4',
        title: '系统预警',
        subs: [
            {
                index: 'qqBot',
                title: 'QQ机器人'
            },
            {
                index: 'apiInfo',
                title: '后端Api接口测试'
            },
            {
                index: 'userNoticeConfig',
                title: '预警账户'
            },
            {
                index: 'systemLog',
                title: '系统日志'
            }
        ]
    },
    {
        icon: 'el-icon-lx-file',
        index: '1',
        title: '系统管理',
        subs: [
            {
                index: 'roleInfo',
                title: '角色信息'
            },
            {
                index: 'permission',
                title: '权限信息'
            },
            {
                index: 'whiteUrl',
                title: '白名单管理'
            },
            {
                index: 'role',
                title: '内部人员管理'
            },
            {
                index: 'projectGroup',
                title: '项目组信息'
            },
        ]
    },
    {
        icon: 'el-icon-lx-file',
        index: '2',
        title: '项目相关',
        subs: [
            {
                icon: 'el-icon-lx-addressbook',
                index: '4',
                title: '实名相关',
                subs: [
                    {
                        index: 'AntiProjectData',
                        title: 'ProjectData'
                    },
                    {
                        index: 'Players',
                        title: '玩家信息'
                    },
                    // {
                    //     index: 'AntiaddictionTest',
                    //     title: '本地白名单'
                    // },
                ]
            },
            // {
            //     index: 'ProjectPath',
            //     title: '项目信息'
            // },
            {
                index: 'projectFile',
                title: '项目文件'
            },
            {
                index: 'upload',
                title: '项目上传'
            },
            {
                index: 'ProjectInfo',
                title: '文件信息'
            },
            {
                index: 'advert',
                title: '广告管理'
            },
            {
                index: 'newProjectInfo',
                title: '新版项目信息'
            },
            {
                index: 'gameDetail',
                title: '游戏详情'
            }

        ]
    },
    {
        icon: 'el-icon-lx-apps',
        index: '3',
        title: '文件系统',
        subs: [
            {
                index: 'fileManager',
                title: '文件管理'
            }
        ]
    },
    {
        icon: 'el-icon-lx-apps',
        index: '3',
        title: '设备相关',
        subs: [
            {
                index: 'deviceInfo',
                title: '设备信息'
            }
        ]
    },
    {
        icon: 'el-icon-s-tools',
        index: '6',
        title: 'GM 相关',
        subs: [
            {
                index: 'Gameconsole',
                title: 'GM 工具'
            },
        ]
    },
    {
        icon: 'el-icon-lx-profile',
        index: '7',
        title: '客服人员',
        subs: [
            {
                index: 'customer',
                title: '客服人员'
            }
        ]
    },
    {
        icon: 'el-icon-info',
        index: '10',
        title: '支付记录',
        subs: [
            {
                index: 'AliPay',
                title: '支付宝支付记录'
            },
            {
                index: 'WxPay',
                title: '微信支付记录'
            }
        ]
    },
    {
        icon: 'el-icon-info',
        index: '11',
        title: '商品相关',
        subs: [
            {
                index: 'Produce',
                title: '商品记录'
            }
        ]
    },
    {
        icon: 'el-icon-s-custom',
        index: '9',
        title: 'SVN相关',
        subs: [
            {
                index: 'svnStatus',
                title: 'SVN状态'
            },
            {
                index: 'svnManage',
                title: '人员管理'
            },
            {
                index: 'svnInsert',
                title: '人员新增'
            },
            {
                index: 'svnAuthorization',
                title: '访问规则'
            },
            {
                index: 'authorizationInfo',
                title: '备份信息'
            },
            {
                index: 'svnEditPersonal',
                title: '修改个人信息'
            },
            {
                title: '未登录'
            },
            {
                title: '登出'
            },
        ]
    }
]

const operationsManager = [
    {
        icon: 'el-icon-lx-home',
        index: 'dashboard',
        title: '系统首页'
    },
    {
        icon: 'el-icon-monitor',
        index: '4',
        title: '系统预警',
        subs: [
            {
                index: 'apiInfo',
                title: '后端Api接口测试'
            },
            {
                index: 'userNoticeConfig',
                title: '预警账户'
            },
            {
                index: 'systemLog',
                title: '系统日志'
            }
        ]
    },
    {
        icon: 'el-icon-lx-file',
        index: '2',
        title: '项目相关',
        subs: [
            {
                icon: 'el-icon-lx-addressbook',
                index: '4',
                title: '实名相关',
                subs: [
                    {
                        index: 'AntiProjectData',
                        title: 'ProjectData'
                    },
                    {
                        index: 'Players',
                        title: '玩家信息'
                    }
                ]
            },
            // {
            //     index: 'ProjectPath',
            //     title: '项目信息'
            // },
            {
                index: 'ProjectInfo',
                title: '文件信息'
            },
            {
                index: 'projectGroup',
                title: '项目组信息'
            },
            {
                title: '广告管理',
                index: "9",
                subs: [
                    {
                        index: 'advert',
                        title: '广告'
                    },
                    {
                        index: 'advertGroup',
                        title: '广告组'
                    },
                ]
            },
            {
                index: 'newProjectInfo',
                title: '新版项目信息'
            },
            {
                index: 'gameDetail',
                title: '游戏详情'
            }

        ]
    },
    {
        icon: 'el-icon-lx-apps',
        index: '3',
        title: '文件系统',
        subs: [
            {
                index: 'fileManager',
                title: '文件管理'
            }
        ]
    },
    {
        icon: 'el-icon-lx-profile',
        index: '7',
        title: '客服人员',
        subs: [
            {
                index: 'customer',
                title: '客服人员'
            }
        ]
    },
    {
        icon: 'el-icon-info',
        index: '10',
        title: '支付记录',
        subs: [
            {
                index: 'AliPay',
                title: '支付宝支付记录'
            },
            {
                index: 'WxPay',
                title: '微信支付记录'
            }
        ]
    },
    {
        icon: 'el-icon-info',
        index: '11',
        title: '商品相关',
        subs: [
            {
                index: 'Produce',
                title: '商品记录'
            }
        ]
    },
]

const designer = [
    {
        icon: 'el-icon-lx-home',
        index: 'dashboard',
        title: '系统首页'
    },
    {
        icon: 'el-icon-lx-file',
        index: '1',
        title: '系统管理',
        subs: [
            {
                index: 'role',
                title: '内部人员管理'
            }
        ]
    },
    {
        icon: 'el-icon-monitor',
        index: '4',
        title: '系统预警',
        subs: [
            {
                index: 'apiInfo',
                title: '后端Api接口测试'
            },
            {
                index: 'userNoticeConfig',
                title: '预警账户'
            },
            {
                index: 'systemLog',
                title: '系统日志'
            }
        ]
    },
    {
        icon: 'el-icon-lx-file',
        index: '2',
        title: '项目相关',
        subs: [
            {
                icon: 'el-icon-lx-addressbook',
                index: '4',
                title: '实名相关',
                subs: [
                    {
                        index: 'AntiProjectData',
                        title: 'ProjectData'
                    },
                ]
            },
            // {
            //     index: 'ProjectPath',
            //     title: '项目信息'
            // },
            {
                index: 'ProjectInfo',
                title: '文件信息'
            },
            {
                index: 'advert',
                title: '广告管理'
            }

        ]
    },
    {
        icon: 'el-icon-lx-apps',
        index: '3',
        title: '文件系统',
        subs: [
            {
                index: 'fileManager',
                title: '文件管理'
            }
        ]
    },
    {
        icon: 'el-icon-lx-apps',
        index: '3',
        title: '设备相关',
        subs: [
            {
                index: 'deviceInfo',
                title: '设备信息'
            }
        ]
    },
    {
        icon: 'el-icon-s-tools',
        index: '6',
        title: 'GM 相关',
        subs: [
            {
                index: 'Gameconsole',
                title: 'GM 工具'
            },
        ]
    },
    {
        icon: 'el-icon-lx-profile',
        index: '7',
        title: '客服人员',
        subs: [
            {
                index: 'customer',
                title: '客服人员'
            }
        ]
    },
    {
        icon: 'el-icon-info',
        index: '11',
        title: '商品相关',
        subs: [
            {
                index: 'Produce',
                title: '商品记录'
            }
        ]
    },
]

const art = [
    {
        icon: 'el-icon-lx-file',
        index: '2',
        title: '项目相关',
        subs: [
            // {
            //     index: 'ProjectPath',
            //     title: '项目信息'
            // },
            {
                index: 'projectGroup',
                title: '项目组信息'
            },
            {
                index: 'projectFile',
                title: '项目文件'
            },

        ]
    },
    {
        icon: 'el-icon-lx-apps',
        index: '3',
        title: '设备相关',
        subs: [
            {
                index: 'deviceInfo',
                title: '设备信息'
            }
        ]
    },
    {
        icon: 'el-icon-monitor',
        index: '4',
        title: '系统预警',
        subs: [
            {
                index: 'apiInfo',
                title: '后端Api接口测试'
            },
            {
                index: 'userNoticeConfig',
                title: '预警账户'
            },
            {
                index: 'systemLog',
                title: '系统日志'
            }
        ]
    },
    {
        icon: 'el-icon-lx-apps',
        index: '3',
        title: '文件系统',
        subs: [
            {
                index: 'fileManager',
                title: '文件管理'
            }
        ]
    },
    {
        icon: 'el-icon-s-custom',
        index: '9',
        title: 'SVN相关',
        subs: [
            {
                index: 'svnEditPersonal',
                title: '修改个人信息'
            },
            {
                title: '未登录'
            },
            {
                title: '登出'
            },
        ]
    }
]

const developer = [
    {
        icon: 'el-icon-lx-home',
        index: '/dashboard',
        title: '系统首页'
    },
    {
        icon: 'el-icon-lx-file',
        index: '1',
        title: '系统管理',
        subs: [
            {
                index: '/roleInfo',
                title: '角色信息'
            },
            {
                index: '/permission',
                title: '权限信息'
            },
            {
                index: '/whiteUrl',
                title: '白名单管理'
            },
            {
                index: '/role',
                title: '内部人员管理'
            },
            {
                index: '/projectGroup',
                title: '项目组信息'
            },
        ]
    },
    {
        icon: 'el-icon-lx-file',
        index: '2',
        title: '项目相关',
        subs: [
            {
                icon: 'el-icon-lx-addressbook',
                title: '实名相关',
                index: '2-1',
                subs: [
                    {
                        index: '/AntiProjectData',
                        title: 'ProjectData'
                    },
                    {
                        index: '/Players',
                        title: '玩家信息'
                    },
                    // {
                    //     index: 'AntiaddictionTest',
                    //     title: '本地白名单'
                    // },
                    {
                        index: '/projectSetting',
                        title: '项目防沉迷设置'
                    },
                    {
                        index: '/antiAddictionSetting',
                        title: '防沉迷模板设置'
                    },
                    {
                        index: '/generatePlayer',
                        title: '生成玩家账号'
                    }
                ]
            },
            // {
            //     index: 'ProjectPath',
            //     title: '项目信息'
            // },
            {
                index: '/projectFile',
                title: '项目文件'
            },
            {
                index: '/upload',
                title: '项目上传'
            },
            {
                index: '/ProjectInfo',
                title: '文件信息'
            },
            {
                title: '广告管理',
                index: '2-2',
                subs: [
                    {
                        index: '/advert',
                        title: '广告'
                    },
                    {
                        index: '/advertGroup',
                        title: '广告组'
                    }
                ]
            },
            {
                index: '/projectVersion',
                title: '项目版本'
            },
            {
                index: '/newProjectInfo',
                title: '新版项目信息'
            },
            {
                index: '/gameDetail',
                title: '游戏详情'
            }

        ]
    },

    {
        icon: 'el-icon-monitor',
        index: '3',
        title: '系统预警',
        subs: [
            {
                index: '/qqBot',
                title: 'QQ机器人'
            },
            {
                index: '/apiInfo',
                title: '后端Api接口测试'
            },
            {
                index: '/userNoticeConfig',
                title: '预警账户'
            },
            {
                index: '/systemLog',
                title: '系统日志'
            }
        ]
    },
    {
        icon: 'el-icon-s-data',
        index: '4',
        title: '数据分析',
        subs: [
            {
                index: '/trackEvent',
                title: '事件管理'
            },
            {
                index: '/trackData',
                title: '埋点事件数据'
            },
            {
                index: '/trackAnalyse',
                title: '报表看板'
            }
        ]
    },
    {
        icon: 'el-icon-lx-apps',
        index: '5',
        title: '文件系统',
        subs: [
            {
                index: '/fileManager',
                title: '文件管理'
            }
        ]
    },
    {
        icon: 'el-icon-lx-apps',
        index: '6',
        title: '设备相关',
        subs: [
            {
                index: '/deviceInfo',
                title: '设备信息'
            }
        ]
    },
    {
        icon: 'el-icon-s-tools',
        index: '7',
        title: 'GM 相关',
        subs: [
            {
                index: '/Gameconsole',
                title: 'GM 工具'
            },
        ]
    },
    {
        icon: 'el-icon-lx-profile',
        index: '8',
        title: '客服人员',
        subs: [
            {
                index: '/customer',
                title: '客服人员'
            }
        ]
    },
    {
        icon: 'el-icon-info',
        index: '9',
        title: '支付记录',
        subs: [
            {
                index: '/AliPay',
                title: '支付宝支付记录'
            },
            {
                index: '/WxPay',
                title: '微信支付记录'
            }
        ]
    },
    {
        icon: 'el-icon-info',
        index: '10',
        title: '商品相关',
        subs: [
            {
                index: '/Produce',
                title: '商品记录'
            }
        ]
    },
    {
        icon: 'el-icon-s-custom',
        index: '12',
        title: 'SVN相关',
        subs: [
            {
                index: '/svnStatus',
                title: 'SVN状态'
            },
            {
                index: '/svnManage',
                title: '人员管理'
            },
            {
                index: '/svnInsert',
                title: '人员新增'
            },
            {
                index: '/svnAuthorization',
                title: '访问规则'
            },
            {
                index: '/authorizationInfo',
                title: '备份信息'
            },
            {
                index: '/svnEditPersonal',
                title: '修改个人信息'
            },
            {
                title: '未登录'
            },
            {
                title: '登出'
            },
        ]
    }
]

const defaultUser = [
    {
        icon: 'el-icon-s-custom',
        index: '9',
        title: 'SVN相关',
        subs: [
            {
                index: 'svnEditPersonal',
                title: '修改个人信息'
            },
            {
                title: '未登录'
            },
            {
                title: '登出'
            },
        ]
    }
]

const thirdOperationsManager = [
    {
        icon: 'el-icon-s-data',
        index: '4',
        title: '数据分析',
        subs: [
            {
                index: '/trackEvent',
                title: '事件管理'
            },
            {
                index: '/trackData',
                title: '埋点事件数据'
            },
            {
                index: '/trackAnalyse',
                title: '报表看板'
            }
        ]
    },
    {
        icon: 'el-icon-folder-opened',
        index: '5',
        title: '文件系统',
        subs: [
            {
                index: '/exportTask',
                title: '导出数据'
            }
        ]
    },
    {
        title: '项目文件管理',
        index: '2-2',
        subs: [
            {
                index: '/projectFile',
                title: '项目发布情况'
            },
            {
                index: '/upload',
                title: '项目上传'
            },
            {
                index: '/ProjectInfo',
                title: '文件信息'
            }
        ]
    }
];

export const PermissionMenu = {
    "程序": developer,
    "美术": art,
    "策划": designer,
    "项目管理员": projectAdministrator,
    "超级管理员": superAdministrator,
    "运营": operationsManager,
    '外部运营': thirdOperationsManager,
    "defaultUser": defaultUser
}
